
<template>
  <div>
    <template v-if="!wapShow">
      <headers :menuIndex="9"></headers>
      <div class="joinUs-box">
        <div class="app-content">
          <el-collapse v-model="activeNames">
            <el-collapse-item style="margin-bottom: 20px" v-for="(item,index) in jobList" :key="item.id" :name="index">
              <template slot="title">
                <div class="text1">
                  <i class="header-icon el-icon-suitcase" style="margin-right: 10px;color: #2c68ff "></i>{{item.name}}</div>
              </template>
              <div class="detail">
                <div>联系人：{{item.contact}}</div>
                <div>联系电话：{{item.contactPhone}}</div>
                <div>联系邮箱：{{item.contactEmail}}</div>
                <hr style="margin: 20px 0" />
                <div>职位详情：</div>
                <div  v-html="item.content"></div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <footers></footers>
    </template>
    <template v-else>
      <wap-index></wap-index>
    </template>
  </div>
</template>


<script type="text/javascript">

  import headers from "@/components/header1"
  import footers from "@/components/footers"
  import eventBus from "../../assets/js/eventBus";
  import wapIndex from "../dataCenter/wapIndex";
  import axios from "axios";
  export default {
    name: 'joinUs',
    components:{headers,footers,wapIndex},
    data(){
      return{
        wapShow:false,
        jobList:[],
        activeNames:[0]
      }
    },
    mounted() {
      eventBus.$on("wapShow",(data)=> {
        this.wapShow = data;
      });
      this.getDataList()
    },
    methods:{
      //获取职位信息
      getDataList(){
        axios.get(this.pageUrl + `/job-position/page?pageNo=1&pageSize=100`).then(res => {
          this.jobList = res.data.data.list
        })
      }
    }

  }
</script>

<style scoped>
  .joinUs-box{
    margin-top: 80px;
    background-color: #F2F4F9;
    padding: 40px 0;
  }
  .joinUs-box .text1{
    font-size: 20px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    letter-spacing:4px;
    padding: 0 20px;
  }
  .joinUs-box .detail{
    font-size: 16px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    padding: 20px 20px 0;
    letter-spacing: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/view/joinUs/index.vue